// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__22Knd","errorLogs":"styles_errorLogs__kDoYv"};